import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { createResourceLocatorString } from '../util/routes';
import { useRouteConfiguration } from '../context/routeConfigurationContext';
import { currentUserSelector } from '../ducks/user.duck';

const useGetEnsuredCurrentUserCallback = () => {
  const currentUser = useSelector(currentUserSelector);
  const routeConfiguration = useRouteConfiguration();
  const location = useLocation();
  const history = useHistory();

  return useCallback(() => {
    if (currentUser) {
      return currentUser;
    }

    const path = createResourceLocatorString('SignupPage', routeConfiguration, {}, {});
    const state = { from: `${location.pathname}${location.search}${location.hash}` };

    history.push(path, state);

    return undefined;
  }, [currentUser, routeConfiguration, location, history]);
};

export default useGetEnsuredCurrentUserCallback;
